import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import { useLanguage } from '../utils/language';
import { isChannelAdmin } from '../utils/permissionConfig';

export default function SpecialPage() {
  const navigate = useNavigate();
  const lang = useLanguage();
  const { userInfo } = useContext(UserContext);

  // 다국어 텍스트
  const TEXT = {
    title: { ko: '특별 페이지', en: 'SPECIAL PAGE', fr: 'PAGE SPÉCIALE' },
    snsTest: { ko: 'SNS 테스트', en: 'SNS TEST', fr: 'TEST SNS' }
  };

  const handleSnsTest = () => {
    navigate('/sns');
  };

  if (!isChannelAdmin(userInfo)) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        color: '#666'
      }}>
        접근 권한이 없습니다.
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: '100vh',
      padding: '20px',
      backgroundColor: '#fff'
    }}>
      <h1 style={{
        fontSize: '24px',
        fontWeight: '300',
        color: '#333',
        marginBottom: '40px',
        textAlign: 'center'
      }}>
        {TEXT.title[lang]}
      </h1>
      
      <button
        onClick={handleSnsTest}
        style={{
          padding: '15px 30px',
          fontSize: '16px',
          fontWeight: '300',
          color: '#333',
          backgroundColor: '#fff',
          border: '1px solid #333',
          borderRadius: '8px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          textTransform: 'uppercase'
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = '#333';
          e.target.style.color = '#fff';
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = '#fff';
          e.target.style.color = '#333';
        }}
      >
        {TEXT.snsTest[lang]}
      </button>
    </div>
  );
}
